import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_StylesForMolType = _resolveComponent("StylesForMolType");
    const _component_IconSwitcher = _resolveComponent("IconSwitcher");
    const _component_FormSelect = _resolveComponent("FormSelect");
    const _component_Section = _resolveComponent("Section");
    return (_openBlock(), _createBlock(_component_Section, { title: "" }, {
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.styleSections, (section) => {
                return (_openBlock(), _createElementBlock("span", {
                    key: section.key
                }, [
                    _createVNode(_component_StylesForMolType, {
                        selAndStyle: section.selAndStyle,
                        molType: section.molType,
                        isBindingPocket: section.isBindingPocket,
                        titleOverride: section.titleOverride
                    }, null, 8, ["selAndStyle", "molType", "isBindingPocket", "titleOverride"])
                ]));
            }), 128)),
            _createVNode(_component_Section, {
                level: 2,
                title: "Hydrogens"
            }, {
                afterTitle: _withCtx(() => [
                    _createVNode(_component_IconSwitcher, {
                        useFirst: _ctx.hydrogenOptionComputed !== 'none',
                        iconID1: ['far', 'eye'],
                        iconID2: ['far', 'eye-slash'],
                        icon2Style: { color: 'lightgray' },
                        width: 24,
                        onClick: _ctx.toggleHydrogensVisible,
                        clickable: true,
                        title: "Toggle Hydrogens",
                        tipPlacement: "left"
                    }, null, 8, ["useFirst", "onClick"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_component_FormSelect, {
                        id: "hydrogens",
                        modelValue: _ctx.hydrogenOptionComputed,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.hydrogenOptionComputed) = $event)),
                        options: _ctx.hydrogenOptions,
                        onOnChange: _ctx.updateHydrogens
                    }, null, 8, ["modelValue", "options", "onOnChange"])
                ]),
                _: 1
            })
        ]),
        _: 1
    }));
}
